import React from "react";
import "./Footer.scss";
import logo from "../../assets/images/logos/techadive_logo.svg";
import { useLocation, useNavigate, Link  } from "react-router-dom";

// ✅ Only LinkedIn
import linkedInIcon from "../../assets/images/icons/linkedin.svg";

const Footer = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const handleScrollTo = (sectionId) => {

        if (location.pathname !== "/") {
            navigate("/");

            // Wait for the homepage to load
            setTimeout(() => {
                const section = document.getElementById(sectionId);
                if (section) {
                    section.scrollIntoView({ behavior: "smooth" });
                }
            }, 600);
        } else {
            const section = document.getElementById(sectionId);
            if (section) {
                section.scrollIntoView({ behavior: "smooth" });
            }
        }
    };

    return (
        <footer className="footer">
            {/* TOP SECTION */}
            <div className="footer__top">
                {/* Brand Section */}
                <div className="footer__brand">
                    <img
                        src={logo}
                        alt="TechADive Logo"
                        className="footer__logo"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                            if (location.pathname !== "/") {
                                navigate("/");
                            } else {
                                window.scrollTo({ top: 0, behavior: "smooth" });
                            }
                        }}
                    />
                    <p>From idea to impact — we build what matters.</p>
                </div>

                {/* Quick Links */}
                <div className="footer__links">
                    <h4>Quick Links</h4>
                    <ul>
                        <li>
                            <Link to="/" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>
                                Home
                            </Link>
                        </li>
                        <li>
                            <a href="#what-we-build" onClick={
                                () => handleScrollTo("what-we-build")
                            }>Services</a>
                        </li>
                        <li>
                            <Link to="/about">
                                About
                            </Link>
                        </li>
                        <li>
                            <Link to="/privacy-policy">
                                Privacy Policy
                            </Link>
                        </li>
                        <li>
                            <Link to="/cookies-policy">
                                Cookies Policy
                            </Link>
                        </li>
                    </ul>
                </div>

                {/* Contact Info */}
                <div className="footer__contact">
                    <h4>Get In Touch</h4>
                    <p><a href="mailto:info@techadive.com">info@techadive.com</a></p>
                    <p>+48 791 285 559</p>
                    <p>
                        Nairobi, Kenya <br /> Warsaw, Poland
                    </p>
                </div>

                {/* CTA Column */}
                <div className="footer__cta-column">
                    <button className="footer__cta" onClick={() => navigate("/contact")}>
                        Let’s Talk
                    </button>
                </div>
            </div>

            {/* ✅ SOCIAL SECTION (Only LinkedIn) */}
            <div className="footer__socials">
                <div className="footer__social">
                    <a
                        href="https://www.linkedin.com/company/tech-a-dive/"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <img src={linkedInIcon} alt="LinkedIn Icon" />
                        <span>LinkedIn</span>
                    </a>
                </div>
            </div>

            {/* COPYRIGHT */}
            <div className="footer__bottom">
                <p>© 2025 TechADive. All rights reserved.</p>
            </div>
        </footer>
    );
};

export default Footer;
